import React from 'react';
import ReactDOM from 'react-dom/client';
import vkBridge from '@vkontakte/vk-bridge';
import App from './App';
import { isVKEnvironment } from './api/vk';
import './theme/theme.css';
import './styles/global.css';

vkBridge.send('VKWebAppInit').catch(() => {});
if (isVKEnvironment()) {
  document.documentElement.classList.add('is-vk');
}

// Apply saved theme before first paint (ThemeProvider re-applies on mount).
const savedTheme = localStorage.getItem('colibri_theme');
if (savedTheme) {
  document.documentElement.setAttribute('data-theme', savedTheme);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
